import { render, staticRenderFns } from "./pwdChange.vue?vue&type=template&id=e79fd24a&scoped=true&"
import script from "./pwdChange.vue?vue&type=script&lang=js&"
export * from "./pwdChange.vue?vue&type=script&lang=js&"
import style0 from "./pwdChange.vue?vue&type=style&index=0&id=e79fd24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79fd24a",
  null
  
)

export default component.exports